<div class="container py-4 bg-whitesmoke">
  <app-breadcrumb [activePanel]="'members'"></app-breadcrumb>
  
  <div class="row justify-content-center">
    <div class="col-12 col-lg-11">
      <!-- Action Buttons -->
      <div class="d-flex justify-content-end gap-3 mb-4">
        <button mat-raised-button color="primary" (click)="exportMembers()" class="export-btn">
          <mat-icon>download</mat-icon>
          Export CSV
        </button>
        <button mat-raised-button color="accent" (click)="importMembers()" class="import-btn">
          <mat-icon>upload</mat-icon>
          Import CSV
        </button>
      </div>

      <!-- Loading state -->
      <div *ngIf="loading" class="d-flex flex-column align-items-center py-5">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Loading members...</p>
      </div>

      <!-- Error state -->
      <div *ngIf="error" class="alert alert-danger d-flex align-items-center gap-2">
        <mat-icon color="warn">error</mat-icon>
        <span>{{ error }}</span>
      </div>

      <!-- Import errors -->
            <div *ngIf="importErrors.length > 0" class="alert alert-warning mt-3 position-relative">
        <mat-icon color="warn">warning</mat-icon>
        <span><strong>Import Errors:</strong></span>
        <ul class="mb-0">
          <li *ngFor="let err of importErrors">{{ err }}</li>
        </ul>
        <button type="button"
                class="btn-close position-absolute top-0 end-0 m-2"
                aria-label="Close"
                (click)="clearImportErrors()"></button>
      </div>

      <!-- Members table -->
      <div class="bg-white rounded shadow-sm p-3" *ngIf="!loading">
        <tt-shared-table 
          #sharedTable
          name="members"
          [maxRecordsReached]="isLicenseLimitReached"
          (limitReached)="onLicenseLimitReached()"
          (loadPage)="onLoadPage($event, sharedTable)"
          (getTotal)="onGetTotal($event, sharedTable)"
          (add)="onAdd($event)"
          (update)="onUpdate($event)"
          (delete)="onDelete($event)"
          (deleteBatch)="onDeleteBatch($event)"
          (deleteAllEmit)="onDeleteAll()"
          (uploadFile)="onUploadFile($event)"
          (importData)="onImportData($event)"
        ></tt-shared-table>
      </div>
    </div>
  </div>
</div>
<!-- License Limit Reached Popup -->
<div class="limit-popup-overlay" *ngIf="showLicensePopup" 
     (click)="showLicensePopup = false">
  <div class="limit-popup" (click)="$event.stopPropagation()">
    <h3>License Limit Reached</h3>
    <p>{{ licenseBlockMessage }}</p>
    <div class="d-flex gap-3 justify-content-center mt-3">
      <button mat-button (click)="showLicensePopup = false" class="cancel-btn">
        Cancel
      </button>
      <button mat-raised-button color="primary" (click)="goToUpgradeLicense()">
        Upgrade License
      </button>
    </div>
  </div>
</div>